import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.harness');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-harness',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.harness/view.scss */
/* src/app/page.harness/view.scss: no such file or directory */`],
})
export class PageHarnessComponent implements OnInit {
    public loading: boolean = true;
    public error: string = '';
    public overall: any = { status: 'empty', updated: '', route: '/harness' };
    public cards: any[] = [];
    public checks: any[] = [];
    public pipeline: any[] = [];
    public issues: any[] = [];
    public failedRuns: any[] = [];
    public tableCounts: any[] = [];
    public collections: any[] = [];
    public storage: any = {};
    public counts: any = {};

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.allow("/access")) return;
        if (!this.canRead()) {
            this.error = '작업 환경은 시스템관리자만 확인할 수 있습니다.';
            this.loading = false;
            await this.service.render();
            return;
        }
        await this.load();
    }

    public canRead() {
        const role = String(this.service.auth.session?.role || '').toLowerCase();
        return ['system', 'admin'].indexOf(role) >= 0;
    }

    public async load() {
        if (!this.canRead()) {
            this.error = '작업 환경은 시스템관리자만 확인할 수 있습니다.';
            this.loading = false;
            await this.service.render();
            return;
        }

        this.loading = true;
        this.error = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call("overview");
            if (code === 200) {
                this.overall = data.overall || { status: 'empty', updated: '', route: '/harness' };
                this.cards = data.cards || [];
                this.checks = data.checks || [];
                this.pipeline = data.pipeline || [];
                this.issues = data.issues || [];
                this.failedRuns = data.failedRuns || [];
                this.tableCounts = data.tableCounts || [];
                this.collections = data.collections || [];
                this.storage = data.storage || {};
                this.counts = data.counts || {};
            } else {
                this.error = data?.message || '작업 환경 상태를 불러오지 못했습니다.';
            }
        } catch (error: any) {
            this.error = error?.message || '작업 환경 상태를 불러오지 못했습니다.';
        }

        this.loading = false;
        await this.service.render();
    }

    public number(value: any) {
        return Number(value || 0).toLocaleString();
    }

    public shortId(value: any) {
        const text = String(value || '');
        if (!text) return '-';
        return text.length > 10 ? text.slice(0, 8) : text;
    }

    public runTypeLabel(value: string) {
        switch (String(value || '')) {
            case 'literature.artifact': return '자료 처리';
            case 'dataset.artifact': return 'QA 후보 생성';
            case 'review.inspect': return '검수 점검';
            case 'eval.run': return '평가 실행';
            default: return value || '처리 작업';
        }
    }

    public statusLabel(status: string) {
        switch (status) {
            case 'ready': return '정상';
            case 'active': return '활성';
            case 'pending': return '진행 중';
            case 'attention': return '확인 필요';
            case 'empty': return '데이터 없음';
            case 'failed': return '실패';
            case 'blocked': return '보류';
            case 'discovered': return '등록됨';
            case 'imported': return '등록됨';
            case 'parsed': return '분석됨';
            case 'indexed': return '색인됨';
            case 'completed': return '완료';
            default: return status || '-';
        }
    }

    public statusClass(status: string) {
        switch (status) {
            case 'ready':
            case 'active':
            case 'discovered':
            case 'imported':
            case 'parsed':
            case 'indexed':
            case 'completed':
                return 'border-emerald-200 bg-emerald-50 text-emerald-700';
            case 'pending':
            case 'empty':
                return 'border-amber-200 bg-amber-50 text-amber-700';
            case 'attention':
            case 'failed':
            case 'blocked':
                return 'border-rose-200 bg-rose-50 text-rose-700';
            default:
                return 'border-gray-200 bg-gray-50 text-gray-600';
        }
    }

    public toneClass(tone: string) {
        switch (tone) {
            case 'green': return 'border-emerald-100 bg-emerald-50 text-emerald-700';
            case 'red': return 'border-rose-100 bg-rose-50 text-rose-700';
            case 'amber': return 'border-amber-100 bg-amber-50 text-amber-700';
            case 'blue': return 'border-sky-100 bg-sky-50 text-sky-700';
            default: return 'border-gray-100 bg-gray-50 text-gray-700';
        }
    }

    public barClass(status: string) {
        switch (status) {
            case 'ready':
            case 'discovered':
            case 'imported':
            case 'parsed':
            case 'indexed':
            case 'completed':
                return 'bg-emerald-500';
            case 'attention': return 'bg-rose-500';
            case 'pending': return 'bg-amber-500';
            default: return 'bg-gray-300';
        }
    }
}

export default PageHarnessComponent;